<template>
  <!--10-5用户教育机构人才列表查看页面 -->
  <div class="main-css">
    <!--标题-->
    <div class="title-css">{{ $t("talentPool") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("postingNewTalent")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="jump3"
          ref="multipleTable"
          :data="tableData"
          style="width: 95%"
          height="425"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="resumeId"
            label="人材番号"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                @click.stop="
                  jump(scope.row.resumeId, scope.row.applicationStatus)
                "
                >{{ scope.row.resumeId }}</span
              >
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="name"
            label="氏名"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                @click.stop="
                  jump2(scope.row.resumeId, scope.row.applicationStatus)
                "
                >{{ scope.row.name }}</span
              >
            </template>
          </el-table-column>
          <!-- ----------------------性別---------------------- -->
          <el-table-column
            prop="sex"
            label="性別"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ sex === "" ? "All" : sex
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item1, index) in SexData"
                    :key="item1.code"
                    :command="item1"
                    >{{ item1.name }}</el-dropdown-item
                  >
                  <el-dropdown-item command="del">{{
                    $t("cancel")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpsex_dictText
              }}</span>
              <span v-else>{{ scope.row.sex_dictText }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------就職担当---------------------- -->
          <el-table-column
            prop="principal"
            width="140"
            label="就職担当"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("inauguration") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.principal }}
            </template>
          </el-table-column>
          <!-- -----------------------生年月日----------------------- -->
          <!-- <el-table-column
            prop="birth"
            label="生年月日"
            width="210"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-date-picker
                v-model="searchData5"
                type="datetimerange"
                range-separator="~"
                :start-placeholder="$t('deliveryTimein')"
                :end-placeholder="$t('deliveryTimeout')"
                class="data-timer-picker"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd HH-mm-ss"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth }}
            </template>
          </el-table-column> -->
          <!-- ------------------------学歴------------------------ -->
          <el-table-column
            prop="education"
            label="学歴"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <div class="el-dropdown-css-2">
                <el-dropdown @command="handleCommandeducation">
                  <span class="el-dropdown-link">
                    {{ education === "" ? "All" : education
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in educationData"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpeducation_dictText
              }}</span>
              <span v-else>{{ scope.row.education_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------専攻-------------------------- -->
          <el-table-column
            prop="profession"
            label="専攻"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.profession }}
            </template>
          </el-table-column>
          <!-- --------------------------日本語-------------------------- -->
          <el-table-column
            prop="japanese"
            label="日本語"
            sortable
            width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japaneseVs") }}</p>
              <div class="el-dropdown-css-3">
                <el-dropdown @command="handleCommandjapanese">
                  <span class="el-dropdown-link">
                    {{ japanese === "" ? "All" : japanese
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in japaneseData"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpjapanese_dictText
              }}</span>
              <span v-else>{{ scope.row.japanese_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------観覧回数-------------------------- -->
          <el-table-column
            prop="visitedTime"
            label="観覧回数"
            width="150"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
          <!-- --------------------------状态-------------------------- -->
          <el-table-column
            prop="applicationStatus"
            label="観覧回数"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("status") }}</p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpapplicationStatus_dictText
              }}</span>
              <span v-else>{{ scope.row.applicationStatus_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------操作-------------------------- -->
          <el-table-column label="操作" width="150">
            <template slot="header">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <el-dropdown @command="handleStatus">
                <el-button type="primary" class="save-button">
                  {{ $t("changeState") }}
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in StatusData"
                    :key="item.code"
                    :command="beforeHandleCommand(item, scope.row.resumeId)"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 个人简历弹出层 -->
      <el-dialog
        title="个人简历浏览"
        :visible.sync="addDialogVisible"
        width="580px"
      >
        <div class="left-box">
          <!-- 主要信息部分 -->
          <div class="main-left-box">
            <!-- 显示图片 -->
            <div class="case-img">
              <!--图片未传-->
              <div class="one-box-left1">
                <img
                  :src="
                    'https://test202257.oss-cn-shanghai.aliyuncs.com/' +
                      infoList.avatar
                  "
                  alt=""
                  @error="
                    e => {
                      e.target.src = require('@/assets/defaultImg.png');
                    }
                  "
                />
              </div>
              <div class="one-box-left2">
                <div class="one-box-left-line1">
                  <div class="one-box-left-line-smallleft">
                    <p></p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ infoList.anonym }}</p>
                  </div>
                </div>
                <div class="one-box-left-line2">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("name") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ infoList.name }}</p>
                  </div>
                </div>
                <div class="one-box-left-line3">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("sex") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ infoList.sex }}</p>
                  </div>
                </div>
                <div class="one-box-left-line4">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("birth") }}</p>
                  </div>
                  <div
                    class="one-box-left-line-smallright"
                    v-if="infoList.birth"
                  >
                    <p>{{ infoList.birth.split(" ")[0] }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 标签部分 -->
            <div class="label">
              <div
                :class="label1 ? 'label-box' : 'label-box-active'"
                @click="labelIsShow(1)"
              >
                {{ $t("foreignersWelcome")
                }}<span @click.stop="labelDel(1)">×</span>
              </div>
              <div
                :class="label2 ? 'label-box' : 'label-box-active'"
                @click="labelIsShow(2)"
              >
                {{ $t("inexperiencedOK")
                }}<span @click.stop="labelDel(2)">×</span>
              </div>
              <div
                :class="label3 ? 'label-box' : 'label-box-active'"
                @click="labelIsShow(3)"
              >
                {{ $t("newGraduateOK")
                }}<span @click.stop="labelDel(3)">×</span>
              </div>
              <div
                :class="label4 ? 'label-box' : 'label-box-active'"
                @click="labelIsShow(4)"
              >
                {{ $t("educationalBackgroundMatter")
                }}<span @click.stop="labelDel(4)">×</span>
              </div>
            </div>
            <!-- 第一行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("contactAddress") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("currentAddress")
                  }}<el-tooltip
                    :content="infoList.address"
                    placement="top"
                    v-if="infoList.address"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.address }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("email")
                  }}<el-tooltip
                    :content="infoList.email"
                    placement="top"
                    v-if="infoList.email"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.email }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("telephoneNumber")
                  }}<el-tooltip
                    :content="infoList.telephone"
                    placement="top"
                    v-if="infoList.telephone"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.telephone }}
                    </div></el-tooltip
                  >
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("education") }}</div>

                <div class="inline-left-title-main">
                  {{ $t("period") }}
                  <div class="inline-left-title-main-right">
                    <el-tooltip
                      :content="infoList.enrollment.split(' ')[0]"
                      placement="top"
                      v-if="infoList.enrollment"
                    >
                      <span>
                        {{ infoList.enrollment.split(" ")[0] }}
                      </span></el-tooltip
                    >
                    &#12288;<el-tooltip
                      :content="infoList.enrollment.split(' ')[0]"
                      placement="top"
                      v-if="infoList.enrollment"
                    >
                      <span>
                        {{ infoList.enrollment.split(" ")[0] }}
                      </span></el-tooltip
                    >
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("school")
                  }}<el-tooltip
                    :content="infoList.school"
                    placement="top"
                    v-if="infoList.school"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.school }}
                    </div>
                  </el-tooltip>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("major")
                  }}<el-tooltip
                    :content="infoList.profession"
                    placement="top"
                    v-if="infoList.profession"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.profession }}
                    </div></el-tooltip
                  >
                </div>
              </div>
            </div>
            <!-- 第二行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("qualification") }}</div>
                <el-tooltip
                  :content="infoList.qualification1"
                  placement="top"
                  v-if="infoList.qualification1"
                >
                  <div class="inline-left-title-main">
                    {{ infoList.qualification1 }}
                  </div></el-tooltip
                >
                <el-tooltip
                  :content="infoList.qualification2"
                  placement="top"
                  v-if="infoList.qualification2"
                >
                  <div class="inline-left-title-main">
                    {{ infoList.qualification2 }}
                  </div>
                </el-tooltip>
                <el-tooltip
                  :content="infoList.qualification3"
                  placement="top"
                  v-if="infoList.qualification3"
                >
                  <div class="inline-left-title-main">
                    {{ infoList.qualification3 }}
                  </div>
                </el-tooltip>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("workHistory") }}</div>

                <div class="inline-left-title-main">
                  {{ $t("period") }}
                  <div class="inline-left-title-main-right">
                    <el-tooltip
                      :content="infoList.startYear.split(' ')[0]"
                      placement="top"
                      v-if="infoList.startYear"
                    >
                      <span>
                        {{ infoList.startYear.split(" ")[0] }}
                      </span>
                    </el-tooltip>
                    &#12288;<el-tooltip
                      :content="infoList.endYear.split(' ')[0]"
                      placement="top"
                      v-if="infoList.endYear"
                    >
                      <span>
                        {{ infoList.endYear.split(" ")[0] }}
                      </span></el-tooltip
                    >
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("companyName")
                  }}<el-tooltip
                    :content="infoList.institutionName"
                    placement="top"
                    v-if="infoList.institutionName"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.institutionName }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("affiliation")
                  }}<el-tooltip
                    :content="infoList.type"
                    placement="top"
                    v-if="infoList.type"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.type }}
                    </div></el-tooltip
                  >
                </div>
              </div>
            </div>
            <!-- 第三行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("languageSkills") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("japanese")
                  }}<el-tooltip
                    :content="infoList.japanese"
                    placement="top"
                    v-if="infoList.japanese !== ''"
                  >
                    <div class="inline-left-title-main-right">
                      JLPT {{ infoList.japanese }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("english")
                  }}<el-tooltip
                    :content="infoList.english"
                    placement="top"
                    v-if="infoList.english !== ''"
                  >
                    <div class="inline-left-title-main-right">
                      TOEIC {{ infoList.english }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("other")
                  }}<el-tooltip
                    :content="infoList.other"
                    placement="top"
                    v-if="infoList.other"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.other }}
                    </div></el-tooltip
                  >
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("request") }}</div>

                <div class="inline-left-title-main">
                  {{ $t("joinCompany") }}
                  <div class="inline-left-title-main-right">
                    <el-tooltip
                      :content="infoList.startYear.split(' ')[0]"
                      placement="top"
                      v-if="infoList.startYear"
                    >
                      <span>
                        {{ infoList.startYear.split(" ")[0] }}
                      </span></el-tooltip
                    >
                    &#12288;<el-tooltip
                      :content="infoList.endYear.split(' ')[0]"
                      placement="top"
                      v-if="infoList.endYear"
                    >
                      <span>
                        {{ infoList.endYear.split(" ")[0] }}
                      </span></el-tooltip
                    >
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("workLocation") }}
                  <div class="inline-left-title-main-right">
                    <el-tooltip
                      :content="infoList.workPlace"
                      placement="top"
                      v-if="infoList.workPlace"
                    >
                      <div class="inline-left-title-main-right">
                        {{ infoList.workPlace }}
                      </div>
                    </el-tooltip>
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("occupation") }}
                  <el-tooltip
                    :content="infoList.profession"
                    placement="top"
                    v-if="infoList.profession"
                  >
                    <div class="inline-left-title-main-right">
                      {{ infoList.profession }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>

            <!-- 第五行 -->
            <div class="inline-log-box">
              <div class="long-box-title">{{ $t("selfPR") }}</div>
              <el-tooltip
                :content="infoList.pr"
                placement="top"
                v-if="infoList.pr"
              >
                <div class="long-box-main">
                  {{ infoList.pr }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="total"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  adminResumeInfoQuery,
  educateResumeInfoQuery,
  educationResumeInfoFuzzyQuery,
  educationResumeInfoQuery,
  educationUserInfoQuery,
  fuzzyApplyResumeInfo,
  queryApplyResumeInfo,
  resumeDetailQuery,
  resumeInfoQuery,
  resumeStatusUpdate,
  resumeUpdateStatus,
  selectMedicalInstitutionUser
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "userEducationalInstitutionTalentListView",
  components: {},
  data() {
    return {
      anonym: "",
      resumeId: "",
      name: "",
      sex: "",
      jobHunting: "",
      birth: "",
      education: "",
      profession: "",
      japanese: "",
      visitedTime: "",
      principal: "",
      total: 0,
      inputData1: "", //搜索框input内容
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      dropdownData1: "", //第一个下拉
      infoList: [],
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      label1: true,
      label2: true,
      label3: true,
      label4: true,
      searchDataStart: "",
      dialogPersonalResumeShow: true, //dialog个人简历
      addDialogVisible: false,
      StatusData: [],
      SexData: [],
      principalData: [],
      statusCode: "",
      sexCode: "",
      principalCode: "",
      resumeIdList: "",
      educationId: "",
      birthEnd: "",
      birthStart: "",
      educationCode: "",
      educationData: [],
      japaneseCode: "",
      japaneseData: []
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.educationId = this.$route.query.educationId;
    this.resumeId = this.$route.query.resumeId;
    this.getEducationResumeInfoQuery();
    this.getApplyStatus();
    this.getSex();
    this.geteducation();
    this.getjapanese();
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //判断是模糊查询还是准确查询
    queryJudgment() {
      if (
        this.birthEnd === "" &&
        this.birthStart === "" &&
        this.education === "" &&
        this.jpCode === "" &&
        this.searchData2 === "" &&
        this.principal === "ALL" &&
        this.searchData1 === "" &&
        this.searchData7 === "" &&
        this.sexCode === ""
      ) {
        this.getEducationResumeInfoQuery();
      } else {
        this.handleEducationResumeInfoFuzzyQuery();
      }
    },
    languageChange(e) {
      const that = this;
      console.log("------监听数据6------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.queryJudgment();
        that.getApplyStatus();
        that.getSex();
        that.getjapanese();
        that.geteducation();
      }
    },
    //跳转页面 0:7-7 其他弹窗显示
    jump(resumeId, applicationStatus) {
      if (applicationStatus === 0) {
        this.$router.push({
          path: "/userEducationInstitutionsToModifyTheSchedule1",
          name: "userEducationInstitutionsToModifyTheSchedule1",
          params: { resumeId: resumeId }
        });
      }
    },
    //点击 名 进入人才详情弹窗
    jump2(resumeId, applicationStatus) {
      if (applicationStatus !== 0) {
        this.getResumeDetailQuery(resumeId);
        this.addDialogVisible = true;
      } else {
        this.$router.push({
          path: "/userEducationInstitutionsToModifyTheSchedule1",
          name: "userEducationInstitutionsToModifyTheSchedule1",
          params: { resumeId: resumeId }
        });
      }
      // this.getResumeDetailQuery(resumeId);
      // this.addDialogVisible = true;
    },
    //点击 行 进入11-3
    jump3(row) {
      if (row.applicationStatus !== 0) {
        this.$router.push({
          path: "/educationalInstitutionsTalentApplicationList",
          name: "educationalInstitutionsTalentApplicationList",
          params: { row: row }
        });
      } else {
        this.$router.push({
          path: "/userEducationInstitutionsToModifyTheSchedule1",
          name: "userEducationInstitutionsToModifyTheSchedule1",
          params: { resumeId: row.resumeId }
        });
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    handleCurrentChange(evt) {
      this.currentPage = evt;

      console.log(this.currentPage);
      this.queryJudgment();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.getEducationResumeInfoQuery();
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.resumeIdList = this.multipleSelection[0].resumeId;
    },
    handleAddClick() {
      console.log("＋新たなbutton");
      this.$router.push({
        path: "/educationTalentAddOne",
        name: "educationTalentAdd1"
      });
    },
    //下拉提示
    handleCommandSex(evt) {
      if (evt === "del") {
        this.sexCode = "";
        this.sex = "";
      } else {
        this.sexCode = evt.code;
        this.sex = evt.name;
      }
      this.handleEducationResumeInfoFuzzyQuery();
    },

    //获取education下拉
    handleCommandeducation(evt) {
      if (evt === "del") {
        this.educationCode = "";
        this.education = "";
      } else {
        this.educationCode = evt.code;
        this.education = evt.name;
      }
      this.handleEducationResumeInfoFuzzyQuery();
    },
    //获取japanese下拉
    handleCommandjapanese(evt) {
      if (evt === "del") {
        this.japaneseCode = "";
        this.japanese = "";
      } else {
        this.japaneseCode = evt.code;
        this.japanese = evt.name;
      }
    },
    handleCommandStatus(evt) {
      this.statusCode = evt.code;
      this.status = evt.name;
    },
    //将id写进command
    beforeHandleCommand(item, id) {
      return {
        item: item,
        id: id
      };
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = false;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = false;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = false;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = false;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("外国人歓迎") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("未経験 OK") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("新卒 OK") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("学歴問わない") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("外国人歓迎");
      } else if (num === 2) {
        this.labelListHandle.push("未経験 OK");
      } else if (num === 3) {
        this.labelListHandle.push("新卒 OK");
      } else if (num === 4) {
        this.labelListHandle.push("学歴問わない");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "外国人歓迎") {
            this.labelListHandle.splice(i, 1);
            this.label1 = true;
            console.log("关闭 外国人歓迎 标签");
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "未経験 OK") {
            this.labelListHandle.splice(i, 1);
            this.label2 = true;
            console.log("关闭 未経験 OK 标签");
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "新卒 OK") {
            this.labelListHandle.splice(i, 1);
            this.label3 = true;
            console.log("关闭 新卒 OK 标签");
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "学歴問わない") {
            this.labelListHandle.splice(i, 1);
            this.label4 = true;
            console.log("关闭 学歴問わない 标签");
          }
        }
      }
      console.log(this.labelListHandle);
    },
    //dialog关闭
    handleCloseDialog() {
      this.dialogPersonalResumeShow = false;
    },

    //变更人才状态信息
    handleStatus(evt) {
      var fescInfo = {
        status: parseInt(evt.item.code) + 1,
        resumeId: evt.id
      };
      resumeUpdateStatus(fescInfo)
        .then(res => {
          console.log("--------修改人才状态信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.getEducationResumeInfoQuery();
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("234567");
            console.log(aesFecInfo);
            if (aesFecInfo.message === "更新成功") {
              this.$message.success({
                message: this.$t("upSuccess")
              });
            } else {
              this.$message({
                message: aesFecInfo.message,
                type: "warning"
              });
            }
          }
        })
        .catch(res => {
          console.log("修改人才状态接口异常:", res);
        });
    },
    //个人简历dialog出现
    personalResume() {
      this.dialogPersonalResumeShow = true;
    },
    //data -time 选择
    dataTimeChange() {
      console.log(this.searchData5);
      this.birthStart = this.timeJs(this.searchData5[0]);
      this.birthEnd = this.timeJs(this.searchData5[1]);
      this.handleEducationResumeInfoFuzzyQuery();
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //清空时间
    pickerChangeFn(value) {
      if (value === null) {
        this.birthStart = "";
        this.birthEnd = "";
        this.handleEducationResumeInfoFuzzyQuery();
      }
    },
    //接口

    //当前教育机构人才信息查询 总
    getEducationResumeInfoQuery() {
      var pageDTO = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      educationResumeInfoQuery(pageDTO)
        .then(res => {
          console.log("--------当前教育机构人才信息查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.total = aesFecInfo.total;
          } else if (res.data.code === 10030) {
            // 审核中
            window.location.href = "#/userApplying";
          } else if (res.data.code === 10010) {
            // 审核拒绝
            window.location.href = "#/educationAuditFailure";
          } else if (res.data.code === 10001) {
            // 审核未通过
            window.location.href = "#/userFailure";
          }
        })
        .catch(res => {
          console.log("当前教育机构人才信息查询接口异常:", res);
        });
    },
    //应聘人才信息模糊查询
    handleEducationResumeInfoFuzzyQuery() {
      var resumeFuzzyQueryDTO = {
        birthEnd: this.birthEnd,
        birthStart: this.birthStart,
        education: this.educationCode,
        japanese: this.searchData8,
        name: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        principal: this.principal,
        profession: this.searchData7,
        resumeId: this.searchData1,
        sex: this.sexCode
      };
      educationResumeInfoFuzzyQuery(resumeFuzzyQueryDTO)
        .then(res => {
          console.log("--------应聘人才信息模糊查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            console.log(this.tableData);
          }
        })
        .catch(res => {
          console.log("应聘人才信息模糊查询接口异常:", res);
        });
    },
    getResumeDetailQuery(resumeId) {
      var fescInfo = {
        //resumeId:"2da41ebca92545388edb89ce3f513vcb"
        resumeId: resumeId
      };
      resumeDetailQuery(fescInfo)
        .then(res => {
          console.log("--------人才信息详情查看接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo.data[0]);
            this.infoList = aesFecInfo.data[0];
          }
        })
        .catch(res => {
          console.log("人才信息详情查看接口异常:", res);
        });
    },
    getApplyStatus() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpresumeStatusChange";
      } else {
        dataItems = "resumeStatusChange";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log(
              "--------获取数据字典接口数据resumeStatusChange--------"
            );
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.StatusData = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getSex() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpsex";
      } else {
        dataItems = "sex";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据sex--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.SexData = aesFecInfo.data;
            console.log(that.SexData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getjapanese() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpjapanese";
      } else {
        dataItems = "japanese";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据japanese--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.japaneseData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.japaneseData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    geteducation() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpeducation";
      } else {
        dataItems = "education";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据education--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.educationData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 70px 80px;
  box-sizing: border-box;
}
.table /deep/ .el-date-editor {
  width: 210px;
}
.left-box {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.top-title {
  height: 40px;
  width: 530px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}
.main-left-box {
  width: 568px;
  /* padding-right: 18px; */
  margin: 0 auto;
  /*overflow-y: scroll;*/
  overflow-y: hidden;
}
.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}
.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  width: 340px;
  height: 30px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: 82%;
  height: 30px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.long-box-title {
  /*height: 360px;*/
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}
.case-img img {
  width: 100%;
  height: 100%;
}

.one-box-left1 {
  width: 200px;
  height: 120px;
  padding-left: 20px;
  padding-top: 5px;
  /* border-radius: 50%; */
  /* overflow: hidden; */
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}
.button-css {
  width: 200px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.save-button {
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  width: 100%;
  margin-top: 20px;
  height: 430px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}
.operate {
  height: 51px;
}
.table /deep/ .el-dropdown {
  width: 60px;
}
.table-img-css {
  border-radius: 50%;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: -20px;
  width: 67px;
}

.pagination {
  width: 95%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.left-box {
  width: 550px;
  height: 650px;
  /*float: left;*/
  overflow: hidden;
  padding-bottom: 20px;
  position: relative;
}

.main-left-box {
  width: 568px;
  padding-right: 18px;
  height: 650px;
  overflow-y: scroll;
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
}

.case-name {
  height: 55px;
  width: 100%;
}

.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.left-button {
  width: 100%;
  height: 41px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-right {
  width: 240px;
  height: 180px;
  margin-right: 45px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  width: 200px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: 125px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  float: right;
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.long-box-title {
  height: 360px;
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 90%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.info-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.schedule-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.chat-box-css {
  width: 530px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}
.chat-box-css span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.chat-box-css /deep/ .search .el-input__inner {
  background: transparent;
}
.chat-box-css /deep/ .send-message {
  height: 60px;
}
.chat-box-css /deep/ .send-message .el-input__inner {
  border-radius: 0;
  border-bottom: 1px solid #51abff;
}

.main-left-box {
  width: 568px;
  padding-right: 18px;
  /* height: 650px; */
  overflow-y: scroll;
}
.el-dropdown-css-1 /deep/ .el-dropdown {
  width: 120px !important;
  margin-top: 5px;
}
.el-dropdown-css-2 /deep/ .el-dropdown {
  width: 135px !important;
  margin-top: 5px;
}
.el-dropdown-css-3 /deep/ .el-dropdown {
  width: 119px !important;
  margin-top: 5px;
  margin-left: -8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/userEducationalInstitutionTalentListView/index.vue